import { Component, OnInit, Input, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';



@Component({
  selector: 'toa',
  templateUrl: './toa.html',
  styleUrls: ['./toa.css']
})
export class TOA {
  constructor(private route: ActivatedRoute) { }
}



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/toa/toa.ts